import React, {Component} from 'react';
import AppLink from "./AppLink";
import PropTypes from "prop-types";
import Icon from "./Icon";
import SubscribeButton from "./SubscribeButton";

class TagLink extends Component {
  static propTypes = {
    tag: PropTypes.object.isRequired,
    section: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    subscribed: PropTypes.bool
  };

  render() {
    const { tag, section, type } = this.props;

    return (
      <span className={'tag-link'}>
        <AppLink rel="tag" key={tag.slug} to={"/" + type + "/" + (section ? `${section}/` : "new/") + tag.slug}>{tag.name}</AppLink>
        <SubscribeButton tag={tag.slug} className={false} subscribed={this.props.subscribed}>
          <Icon icon={'bell'} />
        </SubscribeButton>
      </span>
    );
  }
}

export default TagLink;